import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Image, Title, Text } from './styled';

class AdvantegeComponent extends Component {
    render() {
        const { img, title, text } = this.props;
        return (
            <Wrapper>
                <Image src={img}/>
                <Title>
                    {title}
                </Title>
                <Text>
                    {text}
                </Text>
            </Wrapper>
        );
    }
}

export default AdvantegeComponent;

AdvantegeComponent.propTypes = {
    img: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
};
